const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderMove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "folder_move_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 152.41,
    y1: 251.15,
    x2: 277.67,
    y2: 251.15,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "folder_move_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 158.41,
    y1: 251.15,
    x2: 271.67,
    y2: 251.15,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "folder_move_svg__linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 209.55,
    y1: 227.96,
    x2: 277.67,
    y2: 227.96,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "folder_move_svg__linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 215.55,
    y1: 227.96,
    x2: 271.67,
    y2: 227.96,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "folder_move_svg__linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 209.55,
    y1: 276.04,
    x2: 277.66,
    y2: 276.04,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "folder_move_svg__linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 215.55,
    y1: 276.04,
    x2: 271.67,
    y2: 276.04,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "folder_move_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 5.007812 25.851562 C 4.5 25.851562 4.082031 25.433594 4.082031 24.925781 L 4.046875 7.035156 C 4.046875 6.785156 4.144531 6.554688 4.320312 6.378906 C 4.496094 6.203125 4.726562 6.105469 4.976562 6.105469 L 10.910156 6.113281 C 11.191406 6.113281 11.457031 6.242188 11.632812 6.464844 L 13.144531 8.355469 L 27.019531 8.375 C 27.527344 8.378906 27.945312 8.792969 27.945312 9.304688 L 27.953125 12.449219 C 27.953125 12.699219 27.855469 12.933594 27.683594 13.109375 C 27.507812 13.285156 27.273438 13.382812 27.027344 13.382812 C 26.515625 13.382812 26.097656 12.964844 26.097656 12.453125 L 26.09375 10.230469 L 12.699219 10.210938 C 12.414062 10.210938 12.152344 10.082031 11.976562 9.863281 L 10.464844 7.96875 L 5.90625 7.964844 L 5.9375 23.996094 C 9.945312 24.003906 25.652344 24.027344 26.964844 24.027344 C 27.214844 24.027344 27.445312 24.125 27.621094 24.300781 C 27.796875 24.476562 27.894531 24.710938 27.894531 24.960938 C 27.890625 25.46875 27.476562 25.886719 26.964844 25.886719 L 5.011719 25.851562 Z M 5.007812 25.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 27.507812 12.453125 C 27.503906 11.527344 27.503906 10.742188 27.5 10.183594 C 27.5 9.90625 27.5 9.6875 27.5 9.535156 C 27.5 9.386719 27.5 9.304688 27.5 9.304688 C 27.5 9.039062 27.285156 8.824219 27.019531 8.824219 L 12.929688 8.800781 L 11.285156 6.742188 C 11.195312 6.628906 11.058594 6.5625 10.910156 6.5625 L 4.976562 6.550781 C 4.847656 6.550781 4.726562 6.601562 4.636719 6.691406 C 4.542969 6.785156 4.492188 6.90625 4.492188 7.035156 L 4.527344 24.925781 C 4.527344 25.191406 4.742188 25.40625 5.011719 25.40625 C 5.011719 25.40625 5.089844 25.40625 5.238281 25.40625 C 7.492188 25.410156 25.550781 25.4375 26.964844 25.4375 C 27.230469 25.4375 27.445312 25.222656 27.445312 24.957031 C 27.445312 24.691406 27.230469 24.476562 26.964844 24.476562 C 25.460938 24.472656 5.011719 24.441406 5.011719 24.441406 L 5.011719 24.921875 C 5.011719 24.921875 5.492188 24.921875 5.492188 24.921875 L 5.460938 7.515625 L 10.675781 7.523438 L 12.324219 9.582031 C 12.414062 9.699219 12.550781 9.765625 12.699219 9.765625 L 27.015625 9.785156 L 27.015625 9.304688 C 27.015625 9.304688 26.535156 9.304688 26.535156 9.304688 C 26.535156 9.304688 26.539062 10.605469 26.542969 12.453125 C 26.542969 12.71875 26.757812 12.933594 27.027344 12.933594 C 27.292969 12.933594 27.507812 12.71875 27.507812 12.449219 Z M 27.507812 12.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 27.015625 25.894531 C 26.503906 25.894531 26.089844 25.476562 26.089844 24.964844 L 26.089844 13.46875 L 5.917969 13.46875 L 5.917969 24.898438 C 5.917969 25.410156 5.5 25.824219 4.988281 25.824219 C 4.476562 25.824219 4.058594 25.410156 4.058594 24.898438 L 4.058594 12.539062 C 4.058594 12.296875 4.160156 12.054688 4.332031 11.882812 C 4.503906 11.710938 4.746094 11.613281 4.988281 11.613281 L 27.015625 11.613281 C 27.261719 11.613281 27.5 11.710938 27.671875 11.882812 C 27.84375 12.058594 27.945312 12.296875 27.945312 12.542969 L 27.945312 24.964844 C 27.945312 25.476562 27.527344 25.894531 27.015625 25.894531 Z M 27.015625 25.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 5.472656 24.898438 L 5.472656 13.023438 L 26.535156 13.023438 L 26.535156 24.964844 C 26.535156 25.234375 26.75 25.449219 27.015625 25.449219 C 27.28125 25.449219 27.5 25.234375 27.5 24.964844 L 27.5 12.542969 C 27.5 12.414062 27.449219 12.289062 27.359375 12.199219 C 27.269531 12.109375 27.144531 12.058594 27.015625 12.058594 L 4.988281 12.058594 C 4.863281 12.058594 4.738281 12.109375 4.648438 12.199219 C 4.558594 12.289062 4.507812 12.414062 4.507812 12.542969 L 4.507812 24.898438 C 4.507812 25.164062 4.722656 25.378906 4.988281 25.378906 C 5.253906 25.378906 5.472656 25.164062 5.472656 24.898438 Z M 5.472656 24.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#folder_move_svg__linear0)"
    },
    d: "M 12.269531 19.621094 C 12.023438 19.621094 11.789062 19.523438 11.613281 19.347656 C 11.4375 19.171875 11.34375 18.941406 11.34375 18.691406 C 11.34375 18.445312 11.441406 18.210938 11.613281 18.035156 C 11.789062 17.859375 12.023438 17.765625 12.269531 17.761719 L 19.734375 17.761719 C 20.246094 17.761719 20.664062 18.175781 20.664062 18.6875 C 20.664062 18.9375 20.566406 19.167969 20.390625 19.34375 C 20.214844 19.519531 19.984375 19.617188 19.734375 19.617188 Z M 12.269531 18.210938 L 12.269531 18.65625 C 12.269531 18.65625 12.257812 18.65625 12.246094 18.667969 C 12.234375 18.675781 12.234375 18.6875 12.234375 18.691406 C 12.234375 18.695312 12.234375 18.707031 12.246094 18.714844 C 12.257812 18.726562 12.265625 18.726562 12.269531 18.726562 L 19.734375 18.722656 C 19.734375 18.722656 19.75 18.722656 19.761719 18.714844 C 19.773438 18.703125 19.773438 18.691406 19.773438 18.691406 C 19.773438 18.6875 19.773438 18.675781 19.761719 18.664062 C 19.75 18.652344 19.742188 18.652344 19.738281 18.652344 L 12.273438 18.65625 L 12.273438 18.210938 Z M 12.269531 18.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#folder_move_svg__linear1)"
    },
    d: "M 12.269531 18.210938 L 19.734375 18.207031 C 20 18.207031 20.21875 18.421875 20.21875 18.6875 C 20.21875 18.953125 20 19.171875 19.734375 19.171875 L 12.269531 19.171875 C 12.003906 19.171875 11.789062 18.957031 11.789062 18.691406 C 11.789062 18.425781 12.003906 18.210938 12.269531 18.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#folder_move_svg__linear2)"
    },
    d: "M 19.734375 19.5 C 19.488281 19.5 19.253906 19.402344 19.078125 19.226562 L 15.867188 16.015625 C 15.691406 15.839844 15.59375 15.605469 15.59375 15.359375 C 15.59375 15.109375 15.691406 14.878906 15.867188 14.703125 C 16.226562 14.339844 16.816406 14.339844 17.179688 14.703125 L 20.390625 17.914062 C 20.566406 18.089844 20.664062 18.324219 20.664062 18.570312 C 20.664062 18.820312 20.566406 19.050781 20.390625 19.226562 C 20.214844 19.402344 19.984375 19.5 19.734375 19.5 Z M 16.523438 15.324219 C 16.515625 15.324219 16.503906 15.328125 16.496094 15.332031 C 16.496094 15.335938 16.488281 15.34375 16.488281 15.359375 C 16.488281 15.375 16.496094 15.378906 16.496094 15.382812 L 19.710938 18.597656 C 19.710938 18.597656 19.722656 18.605469 19.734375 18.605469 C 19.75 18.605469 19.757812 18.597656 19.761719 18.597656 C 19.765625 18.59375 19.773438 18.585938 19.773438 18.570312 C 19.773438 18.554688 19.765625 18.546875 19.761719 18.546875 L 16.546875 15.332031 C 16.542969 15.324219 16.53125 15.320312 16.523438 15.320312 Z M 16.523438 15.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#folder_move_svg__linear3)"
    },
    d: "M 16.863281 15.019531 L 20.074219 18.230469 C 20.265625 18.417969 20.265625 18.722656 20.074219 18.910156 C 19.886719 19.101562 19.582031 19.101562 19.394531 18.910156 L 16.179688 15.699219 C 15.992188 15.511719 15.992188 15.207031 16.179688 15.019531 C 16.371094 14.828125 16.675781 14.828125 16.863281 15.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#folder_move_svg__linear4)"
    },
    d: "M 16.523438 23.078125 C 16.273438 23.078125 16.042969 22.980469 15.867188 22.804688 C 15.691406 22.628906 15.59375 22.398438 15.59375 22.148438 C 15.59375 21.902344 15.691406 21.667969 15.867188 21.492188 L 19.078125 18.28125 C 19.441406 17.917969 20.03125 17.917969 20.390625 18.28125 C 20.753906 18.644531 20.753906 19.230469 20.390625 19.59375 L 17.179688 22.804688 C 17.003906 22.980469 16.769531 23.078125 16.523438 23.078125 Z M 16.5 22.125 C 16.5 22.125 16.488281 22.132812 16.488281 22.148438 C 16.488281 22.164062 16.496094 22.171875 16.5 22.171875 C 16.5 22.175781 16.507812 22.183594 16.523438 22.183594 C 16.539062 22.183594 16.546875 22.175781 16.550781 22.171875 L 19.761719 18.960938 C 19.777344 18.945312 19.773438 18.925781 19.761719 18.910156 C 19.75 18.898438 19.726562 18.898438 19.710938 18.910156 Z M 16.5 22.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#folder_move_svg__linear5)"
    },
    d: "M 16.183594 21.808594 L 19.394531 18.59375 C 19.582031 18.40625 19.886719 18.40625 20.078125 18.59375 C 20.265625 18.785156 20.265625 19.089844 20.078125 19.277344 L 16.863281 22.488281 C 16.675781 22.675781 16.371094 22.675781 16.183594 22.488281 C 15.992188 22.300781 15.992188 21.996094 16.183594 21.808594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderMove);
export default __webpack_public_path__ + "static/media/folder_move.b1017030b8a94a1a26de7fe00fcf686a.svg";
export { ForwardRef as ReactComponent };